import { Link, useLocation } from "react-router-dom";
import { headerClasses } from "./headerClasses";
import { useAppSelector } from "../../hooks/storeHook";

type DashboardNavPage = "current" | "registrations";

type HeaderProps = {
    dashboardNav?: {
    activePage: DashboardNavPage;
    onPageChange: (page: DashboardNavPage) => void;
  };
};

const Header = ({ dashboardNav }: HeaderProps) => {
  const {
    header,
    navContainer,
    navContent,
    linkHome,
    linkSignIn,
    linkProfileAction,
    dashboardNavContainer,
    dashboardNavButton,
    dashboardNavButtonActive,
  } =
    headerClasses;

  const { user, initialized } = useAppSelector((state) => state.auth);
  const location = useLocation();
  const authPath = `/auth${location.search}`;
  const isProfilePage = location.pathname === "/profile";

  return (
    <header className={header}>
      <nav className={navContainer}>
        <div className={navContent}>
          <div className="grid w-full grid-cols-[auto_1fr_auto] items-center gap-3">
            <Link to="/" className="text-lg font-black text-white">
              Sidewinder
            </Link>
            {dashboardNav ? (
              <div className={dashboardNavContainer}>
                <button
                  className={`${dashboardNavButton} ${
                    dashboardNav.activePage === "current"
                      ? dashboardNavButtonActive
                      : ""
                  }`}
                  type="button"
                  onClick={() => dashboardNav.onPageChange("current")}
                >
                  Current
                </button>
                <button
                  className={`${dashboardNavButton} ${
                    dashboardNav.activePage === "registrations"
                      ? dashboardNavButtonActive
                      : ""
                  }`}
                  type="button"
                  onClick={() => dashboardNav.onPageChange("registrations")}
                >
                  Register
                </button>
              </div>
            ) : (
              <span />
            )}
            <div className="flex items-center justify-end gap-2">
            {user && !isProfilePage ? (
              <Link to="/profile" className={linkProfileAction}>
                <span className="grid h-7 w-7 place-content-center rounded-full bg-accent-color-2 text-sm font-black text-black">
                  {user.email[0].toUpperCase()}
                </span>
                <span>Edit profile</span>
              </Link>
            ) : (
              <></>
            )}
            {initialized && Boolean(!user) && (
              <Link to={authPath} className={linkSignIn}>
                Sign in
              </Link>
            )}
            {isProfilePage ? (
              <Link to="/" className={linkHome}>
                Home
              </Link>
            ) : null}
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;
